module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/bitmap-fc0bd73ce5b448999291c30e10c2e1b8.png";